import { handleLogin } from '@store/action/auth/authThunks'
import { toast } from 'react-toastify'
const HandleUserData = (ecSdk, dispatch) => {
    const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : ""

    let auth = undefined
    if (userData) {
        auth = userData?.user_data?.authentication_key
    }

    console.log("auth", auth)
    if (auth) {
        ecSdk.Dropdown.getCurriculumProviderUserData((err, response) => {
            if (err) {
                toast.error("something went wrong")
            }
            if (response && response.status === "success") {
                const data = response.data;
                console.log("data inside handle user data", data)
                dispatch(handleLogin(data)) // Assuming response.data holds the user data
            } else {
                toast.error(response.message)
            }
        }, {
            auth: auth
        })
    }
}

export default HandleUserData